// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/inventory_overview.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { BranchLevelView, StockPointLevelView } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.InventoryOverviewRequest
 */
export class InventoryOverviewRequest extends Message<InventoryOverviewRequest> {
  constructor(data?: PartialMessage<InventoryOverviewRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryOverviewRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryOverviewRequest {
    return new InventoryOverviewRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryOverviewRequest {
    return new InventoryOverviewRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryOverviewRequest {
    return new InventoryOverviewRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryOverviewRequest | PlainMessage<InventoryOverviewRequest> | undefined, b: InventoryOverviewRequest | PlainMessage<InventoryOverviewRequest> | undefined): boolean {
    return proto3.util.equals(InventoryOverviewRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.InventoryOverviewResponse
 */
export class InventoryOverviewResponse extends Message<InventoryOverviewResponse> {
  /**
   * @generated from field: com.neulink.pharmacy.BranchLevelView company_level_view = 1;
   */
  companyLevelView?: BranchLevelView;

  /**
   * @generated from field: com.neulink.pharmacy.BranchLevelView branch_level_view = 2;
   */
  branchLevelView?: BranchLevelView;

  /**
   * @generated from field: com.neulink.pharmacy.StockPointLevelView stock_point_level_view = 3;
   */
  stockPointLevelView?: StockPointLevelView;

  constructor(data?: PartialMessage<InventoryOverviewResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryOverviewResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "company_level_view", kind: "message", T: BranchLevelView },
    { no: 2, name: "branch_level_view", kind: "message", T: BranchLevelView },
    { no: 3, name: "stock_point_level_view", kind: "message", T: StockPointLevelView },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryOverviewResponse {
    return new InventoryOverviewResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryOverviewResponse {
    return new InventoryOverviewResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryOverviewResponse {
    return new InventoryOverviewResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryOverviewResponse | PlainMessage<InventoryOverviewResponse> | undefined, b: InventoryOverviewResponse | PlainMessage<InventoryOverviewResponse> | undefined): boolean {
    return proto3.util.equals(InventoryOverviewResponse, a, b);
  }
}

